export default {
  FlightDuration__HOURS_ABBREVIATION: (data) => `${data.hours}h`,
  FlightDuration__HOURS_ARIA_LABEL: (data) => `${data.hours} hours`,
  FlightDuration__MINUTES_ABBREVIATION: (data) => `${data.minutes}m`,
  FlightDuration__MINUTES_ARIA_LABEL: (data) => `${data.minutes} minutes`,
};
